var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: "Crear actividad para expediente " + _vm.file.numero,
        "hide-footer": "",
        centered: "",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        size: "lg"
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c(
        "div",
        [
          _c("ActivityForm", {
            attrs: {
              "selected-activity": {},
              column: _vm.createdColumn,
              "kanban-id": _vm.currentUserId,
              "reference-id": _vm.file.febosId,
              "reference-type": "EXP",
              "reference-number": _vm.selectedFile.febosId,
              "edit-mode": false,
              "on-updated": function() {
                return (this$1.editMode = false)
              },
              fromProcessedFile: true
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }